module.exports = __webpack_public_path__ + "img/icon-dismiss.f23be032.svg";